export function formatDate(dateString, locale = 'it-IT') {
  if (!dateString) return ''
  const date = new Date(dateString + 'T00:00:00')
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(date)
}

export function formatDateFull(dateString, locale = 'it-IT') {
  if (!dateString) return ''
  const date = new Date(dateString + 'T00:00:00')
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(date)
}

export function formatToday(locale = 'it-IT') {
  return new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date())
}

export function daysUntil(dateString) {
  if (!dateString) return null
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const due = new Date(dateString + 'T00:00:00')
  due.setHours(0, 0, 0, 0)
  return Math.ceil((due - today) / (1000 * 60 * 60 * 24))
}

export function isOverdue(dateString) {
  const d = daysUntil(dateString)
  return d !== null && d < 0
}

export function isDueSoon(dateString, days = 7) {
  const d = daysUntil(dateString)
  return d !== null && d >= 0 && d <= days
}

/** Returns translation key for time-of-day greeting */
export function getGreetingKey() {
  const h = new Date().getHours()
  if (h < 12) return 'greeting_morning'
  if (h < 18) return 'greeting_afternoon'
  return 'greeting_evening'
}

export function todayISO() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// Scala urgenza:
//  overdue (<0) → rosso
//  oggi  (0)    → arancio primary
//  domani (1)   → viola
//  2–7 giorni   → grigio (non critico)
//  8–30 giorni  → ambra
//  >30 giorni   → verde (lontano)
export function urgencyColor(days) {
  if (days === null) return '#9CA3AF'
  if (days < 0)      return '#E74C3C'
  if (days === 0)    return '#FF6B35'
  if (days === 1)    return '#8B5CF6'
  if (days <= 7)     return '#6B7280'
  if (days <= 30)    return '#F39C12'
  return '#27AE60'
}
